import React from "react";
import "./ErrorMessage.css";

const ErrorMessage = ({ error, retry }) => {
  // Parse error message from RTK Query error object
  const getErrorMessage = () => {
    if (!error) return "An unknown error occurred";

    // Handle RTK Query error format
    if (error.data) {
      if (typeof error.data === "string") return error.data;
      if (error.data.error?.message) return error.data.error.message;
      if (error.data.message) return error.data.message;
    }

    // Handle status codes
    if (error.status) {
      switch (error.status) {
        case 401:
          return "Unauthorized - Please login again";
        case 403:
          return "You don't have permission to perform this action";
        case 404:
          return "Resource not found";
        case 500:
          return "Server error - Please try again later";
        default:
          return `Error: ${error.status}`;
      }
    }

    return error.message || "An error occurred";
  };

  return (
    <div className="error-message-container">
      <div className="error-icon">⚠️</div>
      <div className="error-content">
        <p className="error-text">{getErrorMessage()}</p>
        {retry && (
          <button onClick={retry} className="error-retry-btn">
            Try Again
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorMessage;
